import { useState } from 'react';

export default function SocialProof() {
  const [activeIdx, setActiveIdx] = useState(0);

  const testimonials = [
    {
      quote: 'This is the easiest way to find Pandabuy items I\'ve ever used. The spreadsheet format makes shopping 10x faster.',
      name: 'Marcus J.',
      role: 'Streetwear Enthusiast',
      imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20young%20man%20in%20urban%20streetwear%20outfit%20posing%20against%20colorful%20graffiti%20wall%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20fashion%20portrait%20photography%2C%20vibrant%20urban%20culture%20aesthetic&width=400&height=500&seq=testimonial-v2-a&orientation=portrait',
    },
    {
      quote: 'I discovered so many amazing sneakers through this pandabuy spreadsheet. The curated lists save me hours every week.',
      name: 'Elena K.',
      role: 'Fashion Blogger',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20woman%20in%20trendy%20oversized%20blazer%20outfit%20against%20modern%20architectural%20concrete%20wall%2C%20soft%20diffused%20daylight%2C%20editorial%20portrait%20photography%2C%20confident%20cosmopolitan%20aesthetic&width=400&height=500&seq=testimonial-v2-b&orientation=portrait',
    },
    {
      quote: 'Finally a pandabuy sheet that\'s actually organized and updated. The quality comparisons are a game-changer.',
      name: 'David R.',
      role: 'Online Shopper',
      imageUrl: 'https://readdy.ai/api/search-image?query=Young%20man%20in%20casual%20hoodie%20and%20cap%20leaning%20against%20industrial%20brick%20wall%2C%20warm%20afternoon%20sunlight%2C%20editorial%20fashion%20portrait%20photography%2C%20relaxed%20authentic%20street%20style&width=400&height=500&seq=testimonial-v2-c&orientation=portrait',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.15] text-center mb-4">
          What Our <span className="italic">Community</span> Says
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          Thousands of shoppers rely on our pandabuy spreadsheet to discover the best finds every day.
        </p>

        <div className="relative bg-foreground-950 rounded-[32px] p-6 md:p-10 overflow-hidden">
          <div className="absolute -top-12 -left-12 w-40 h-40 rounded-full bg-primary-500/20 blur-3xl"></div>
          <div className="absolute -bottom-12 -right-12 w-40 h-40 rounded-full bg-accent-500/15 blur-3xl"></div>

          <div className="relative">
            {/* Active testimonial */}
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8">
              <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl overflow-hidden flex-shrink-0">
                <img
                  src={testimonials[activeIdx].imageUrl}
                  alt={testimonials[activeIdx].name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <span className="font-heading text-4xl md:text-5xl text-secondary-400/40 leading-none block mb-3">&ldquo;</span>
                <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-4">
                  {testimonials[activeIdx].quote}
                </p>
                <p className="text-sm font-semibold text-background-50">{testimonials[activeIdx].name}</p>
                <p className="text-xs text-background-200/60">{testimonials[activeIdx].role}</p>
              </div>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIdx(idx)}
                  className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${idx === activeIdx ? 'bg-accent-400 w-6' : 'bg-background-100/20 hover:bg-background-100/40'}`}
                  aria-label={`Testimonial ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}